export default "__VITE_ASSET__CYhx4Uc0__"